import './style.scss'

import TeamCampaignStatistics from 'components/molecules/TeamCampaignStatistics'
import { TeamSideId } from 'features/team/const'
import { teamHooks, TeamUI } from 'features/team/index.ts'
import { Redirect } from 'react-router-dom'
import { leftSideHooks } from 'shared/hooks'

import { useLegacyPersonas } from '../useLegacyPersonas'
import { useTempProps } from './temp'

export function StatisticsPage() {
	const showMembers = teamHooks.useIsEnable()

	return showMembers ? <Inner /> : <Redirect to='/team/members' />
}

function Inner() {
	const [personas, { isLoading }] = useLegacyPersonas()

	leftSideHooks.useActive(TeamSideId.Statistics)

	const tempProps = useTempProps()

	return (
		<TeamUI.Wrapper header={<h2 className='teams-main-title'>Statistics</h2>}>
			<TeamCampaignStatistics
				archive={false}
				{...tempProps}
				loader={isLoading}
				personas={personas}
			/>
		</TeamUI.Wrapper>
	)
}
